import { render } from "./student-filter.vue?vue&type=template&id=23926af3"
import script from "./student-filter.vue?vue&type=script&lang=js"
export * from "./student-filter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__